import { Select, DatePicker } from "antd";
import { useRef, useState } from "react";
import { parsePhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import PhoneInput from "react-phone-number-input";
import check from "../../../imgs/add.png";
import { PlusCircleFilled } from "@ant-design/icons";
import across from "../../../imgs/across.png";
import img from "../../../imgs/impLogo.png";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Nationalties } from "../Constants/constant";
import { detectObjectsInImage } from "../../../utlis/modelLoader";
import { message } from "antd";
let rr;
const generatePassword = () => {
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=";
  const length = 10; // Length of the autogenerated password
  let password = "";

  // Function to check if a string contains at least one uppercase letter, one lowercase letter, one number, and one special character
  const hasRequiredCharacters = (str) => {
    const hasUpperCase = /[A-Z]/.test(str);
    const hasLowerCase = /[a-z]/.test(str);
    const hasNumber = /[0-9]/.test(str);
    const hasSpecialChar = /[!@#$%^&*()_+\-=]/.test(str);
    return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
  };

  // Loop until a valid password is generated
  while (!hasRequiredCharacters(password)) {
    password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
  }

  return password;
};
const Mid = () => {
  rr = Nationalties?.map((item) => {
    return {
      lable: `${item}`,
      value: `${item}`,
    };
  });
  useEffect(() => {
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  }, []);
  const [show, setShow] = useState(false);
  // const [display, setDisplay] = useState(
  //   "data:image/png;base64,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"
  // );
  const photo =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABNHSURBVHgB7Z0JdFRVmse/e6sqValUpaqSygbZQyCCEmghiAoaNNIgLSPYgWntpnFsHY+eacXpdjzOjPTRnnE8vRzaaY8409KetkdlTrt0I6LSBgFFWVpZFJA9IWul9iS1vnv7u88GJQSyVb33qsjvnKS2l0rV+79773e/797vI5DCcM6NnZ2dNqPRaKaU5sc5LefAy4GzGsJJPhCSzYBb8VAb/lgJQDbHPyMEApxDEO8G8BHeQoAS0s4JHGESO854vMVAzK05OZk9+FoPISQOKQqBFAIFpX6/39YT5WVGg24eATYHBapBUUtRBDMkELwAwkB4KwG6nzNpuxTjb5tMtNVms/nxfzFIETQv8JEjR4zZzqIaPUjzOINaQskMFLQGX9KBskgEyAEGbBeetY8ZYzsDbvfh6urqCGgYzQocDAbzopJUDwxWYleLooITtIUbfz6gFF5isdg2p9PZChpEUwJjF6x3eQI36gi5FbvH+fhUCQpLQcNgq47j5/4Cb7dzyl7Jtdm2amnM1oTAeIIyvF7vTRLRP0gIvwY4GCEVIRBhjH8IcfZYXp7jQxRaApVRVWDRYru9gUa0YO/DcfUKfMoK6UEMT+02kKRf5+ba/6hmi1ZNYLc7MBsoe4YDmQZpDF64n+pB/32Hw7IXVEBRgbHFElcgUKWT+BM4Gf02aHx8TSCMAH9Bl2n6KU7aj2OL5qAQip1gj8dj6/b676acvIXiLoNLR1wBxZ5qZSwUedsdCNyxfj1XbIqnSAt2+XwzgNP/wqt4HlziiPEYnShb9YQ9jE6TPcluzUkXuMvjWUiBPovfrATG+AoOB0FPHs21WjeiyElzliRN4NbWVrMpK2sNehdvx2+TCWMMAAkRyteGe3oeHT9+fB8kgaQI3OHzVeqB/oZwPlfrjgq1QQEY2iRbpQhdXlBg6YQEk3CBu7q806iBvoF3S2GMIYNCHJeALc13OD6FBJIwgYXTwhsINDAG6/BhAahELB6HvlAIOlzdcKqlDZrb2sHl9oDb64Nujwco1YE1ywwWSxY4cxxQNr4IxhXkQ3FRofzYZFTPiYa9XaceWKPD4dgKCSIhAouIT25+/q1Mgp/jO44DheEYZvIHe2D/wS/go0/2wrGTzfLj4aDTUagsK4VZ06bC9Ck1UFRYoJYXyI+j2p1Oh/VVSAAJ+Q5ub+BO9Ng8hXdzQUGisRgcOnYCdu89APsPHYZOl1v0JDBassxmmP2NWrhqxjSYUFYCxgzFW3WfntDvuVwdG0Ybjhy1wF5vcAmOHb/DuwkNuA/GqdNt8Nqmd+GTzw5CNBqDZJCRYYDJ1VVQXVEGNVVVkJfrgBy7XW7tCuDGa/X+vBzbyzAKRiWwyxusJ8Begy+XxChCa0cXvNX0PuzY/Sn0hcOgFDqdTh6jnQ47FI8rhIkV5VA7eZLc2pMHaWM8viw/J2c7jJARC9zl9U4jQDcRhQwq0fF+sv9zWPv7VyAwzPE1GaBzAgrynHDzvOvgutkzwKA3QDIQhhcDNr/A4RhRsGJEAvt8oYo4j24BhaZC4UgE/u/1DfD+R7uS1h2PFIPBAHPqroQ7ly2RW3kyIITu1YH+Vrs98wQMk2ELjEaM2e3zv4l/ej0ogJje/PdvX4RDR4f93RTlWzfWw3duXQTJg2/Jtdtuxp5jWB6vYVkLYpmqxx9cg/9kLihAt8cHP3v2ec2LK/jT5ibYtXc/JA8y1+0P/hsMkyELLGK5bp9vIWfsdrTukm5Gdnu88Iv/WQcnT2tyLduA/P+Gt6G3LwRJguK5/6HH37tgWH801AO7/f4r8fA1OCAkPXAgTtLja56BE82nIZXo6HLB9p1/gWSBPWcmZ/Fn5fDrEBmSwNh6dQTjuXg36SE/4ah46Y0N0NXtgVRDuEm37dwFcSl5a+3Qqi6lQH4kFlAM5fhBBRZdc7fXfxfeU2Tcfe/Dj+C9Dz6GVKW1oxM8Pj8kE2wD6Fyiy4U2gx07qMAul6sKu4Yf4V09JBkXBgNe27Q5Ie5GtYhEotj7dEOS0eso/edTnZ3lgx04qMA6vfEJvKkCBXgJ57putJxTGXFpKmH1M84nZBszHxzsuIsK7A6Ipa3kNlCAIydOwt7PD0M60I7GlhJwQu6VNboIFxRYxHeZxJ4RBhYkGTT/0Uu1G+O4yvmWk0mwRxlX6tc0uuDweUGBXR7/EqLQonRxxe87mB6tVxBC16qwqJVAaOTyBhou9PqAAotWSym9BxRCxHTFqot0IRqN408UlEJH4H6xv2ug1wYU2O331wPhc0ABhMX82RdHIZ0I9vSisyYpiyQHBA27Od5A34Ct+DyBRX/OOX0E/yo58a9++ANBON2e8MWEquIPBMDtC4CCWBmLrRIZEPq/cN4Tnt7eGzDUeQ0oRA+6JbUQ300kOIWBky0Ku1kJvQZdmFP7P31+Fx1lS7AZK7YIKRKNQCicHtbz1znZonCQBDUjQL/b/+lzBO7w+So48GtBQULhiKIGiVK4MBqmNCjmUpH6ot9zX5FByCx0S04EBRGtN3UdkxcmhHP6eFzZDf54HktCUemcDX5nBRZrmyWJr8AWnHSf8zkfKoX9zhdDzIWjMcV7JqrT0xVfnzKdFTg3N3cSTppnwhgJQQQdJEn5dFqc8Tqv11t45vFZgWMMrkW3iKIL19OZuBSXrWkVyAVdxtlZkCzw+vXrdXq9Pq1zZSgNY1zeUqMGXIpff2ZOLP+aPXu+DZ+4GsZIGBgEANXMC5wTi5SP4q4ssMWhK0HreRKMkTAkLqlmQIpUjxGul9esywKzGLvhYiGnMYaPJLdg1XKW6vTAbhB3aFMTxhSB14NKKD1XVAqGMW6JqTcFFAEIcUunT/db0fdcAyqhVNxUDYQlrRaEgjzk0l7GRPrAYlABYWm2d3ZBuvLFMfV2ZOB8uFTMjqhFZyrE9mwCFfAFg/DhnoSmpNAUm7ftgJ5e5eLC/chqaGgooZF4tAJU4vipFnmLSrpyAiNKbSr2UDFOJ4ucJGWgEgcOfZG2vmiBMLT243dUC0LYZRS7Z1UMLDH++oNBSHc8PvXWeWNsYQrlojqJCjAmYbA//eLA/QmH1fuOQltKCckGNcC5mZo5qZTCkKGe/0hoS/9WV0hx9DodOGzqXFtKkpeTA2ohtBWuSsUy5PSnME9rhVQSj8rf0SYEVq1OwoSKcjm1YLqSYdBDRamqWZStVJR7A5UoyndCdUX65iytqa7CLtoOaiG0pRzUW/MmjKzLJlRCujJz6hVymiW1ENqKLlrVyeg3rpgCen36RSrt2VaonaJ6iD0oBFZ0j0V/qspK4LpZQ84pkhKILHhz8DuJtIcqE6ByiVUVoZTKScTynemz3q+4sAC+ef0ckaEO1IUH8PRSVQUWFKCxtaB+Tlp01Rk45i6ePw9y7KrNPs8itKWMc004hOtnz4K62svl7i1VoX/rmuum14IWENoKV2U7aACjMQPuWLoYKkpUWXuQEGon18CyWxaAQSM9kdCWcsKOgEYQrsu772gEc6Yq6w9GhT07G35weyNYs7JAKzCQDglHx3HQEGXjx8FjD94vn7BUoTAvD37y0P2a861TRg9QPSHNoDFKxxfBysZbwZKlaJWAEWFHUe/93nJNzgIoZYcpY0zkT9DcFvsZaHB95+8WAaHaraslpngrblsMEyvLQWtwDmG73d5MI5FICB9oLq2rOHkzp10BVaXaNbpmTJ0CddOmghZBg/40zkgYPXiwwEMIPwQaxGI2w/JbbkZ/rvbmx1ZLFnyrYZ58IWoTckD8pvX1JE6AbgONctnEKqi9TLV1+RdkBvrQy4qLQKug8SxrKl9+MR5/R8068xdDOA9uWzQfjBkZoBWEtbyooT5plVYSgBSLxN8Rd74UuFfXxjh8BhqlFKdO0y+fDFqhDm0DUe9Qq3Dsnk0mKqf5kQXeseNtPwGu2S0Gwnm5dEEDmM3qlyEWU7f51ymaiGjYUM4+ttlsclZyWeDGxkaJUdgDGkZUG7v+qjpQm4Y5V0ORpluv2JsMm4UFLR5/ZQJGIjgoczdomEU3Xg/ZFguoRXFRgTz2ahnOudtksDWdeXxW4Ly8vM85Jx+ChhHGTXKLT12cJQtvArNJ235yNEo/sFrhbEM9KzA26Siq/3s0WlXblj4URBk5tZilUafGGdBWiXMKL6GWZ9fZnTNLZzFdE1pgx0DDqOlY0K5T4wzkMInFzvFpnPOJCwutXTg0N8EYKQkD/rbT6TwnC+p5lySTpJc5IaOqOp1M1NxuquWtrkIzQuGV/s+fJ7DTad9GgIy4IHGyEdVIL8X/PRiEsw9ys7PPq6t3nsDCZclY7Bc4YmuyiIKoIawW2z7WrKsgxjhbPZC7eUCrIc/h2IwduqbKoIju8cjJU7DxvfdBLbbs2Cnv2NdcV82hCTUbcIp7wSWM3d3eJaCjfwCVEOdQ1B9qbuuQM/GI2ryHjh2HWEzdmIjYUDZl0kS4EqNJJeMKoDA/T16HpeZqUB2weQ6HY0Dj+IKfSmS+8/j8u7hCtZNE+t1OVzec7uiE480tciU0l8cHkXAEQtGoXDxLa4iVoFmZmVDgdEJlWTFMKC+TgxDiR69XZtekiCHk2G0zLxQNvOhl5/X21DLC9iS6+plITtLS1g5HTzbDsVPNeNsiZ6ORpPTIeic2twuRqyvLoLKkGCZWVciPEz2PFqJSTmc4HJa9FzxmsDdxewPPc+ArYQSIXI29fWHocrtlAU+2tMEJbJ1HUdRoNAaXEpno4qwoLYZK/BE+7eKiIijIy8UewDTyLS6cP+XMsT98sUMGFbirq2sCNWRswkOHVIFUmB99fX1w5Pgp2Lpzt9xKRS6sdE6XNBLEmJ2X48BWXg7XXDkdW3k5hkPNMNSRnBI4GgiHbiovLLxoOr1B308UIXb5fN+nQJ+Di9QQFvJ5UMgmtDT37P9M+bIyKY4Yv8VCgqtnToNcu2Oww3G8ZXfm2u0vft3vPBBDumBEOXFG9K+ijPMGej0cicjz0zf//H5a1SBUGtGqi9Aqv2nuNTB39gzINA4cuUKX5Ktb3rVhGJ8MarQM2bZ3u4OTOZE24qc4JzNec2s7vLbpXXkao0YRinREh0aaaM1iW21F/2XDHA7GQbesMMeyfyjvNazJm8fvX8Ak/gcUWV4709LeAb98bh20dyW9pPklSWG+E/79gfu+tiWGY/dI78q1W18frGs+w7DMtxyb7S1847VnYsavb/rzmLhJpAPP7Yuv/unMQzzn5BkUd+NQxRUM2z7PsWc/iobXVjFn3b1vSL3EGKNAnOMv/QN8a649+z/JMCN9wxYY/0GfyaBfTnW64zrVUxSkP+Ic45i8x2SwLRfnHobJiBSyWCydPMaWVpWXjvXPSUacYwnYP1gsZERFlkfcBPPzHZ/qKF2WmWkcEzlJGDMMfRXlxTcXOBx7YYSMqo+tm1S2vaq0/MeWLLN2I+EpislkDM+ovfy+f1px+04YBQmJcT313Lo7t320+9fhcCT1ci9oEAw/+hrmXn3Xvd9dNupwbUKspB/fvfL5q6ZdcY/JaOyFMUZFltncXV4+/sFEiCtIaJT6oZ88ueDwyVOvRCIx1TLYpjJGoyFYO6nmmz/9lx8mbANCQuO8O7ZsPrq4sXFrJBK/NhyJjpWqHTIYWcp1HKocX77syUcfSOjukqSsM/nd+jcmbdm5+4XTHZ11GNxP3cxmCkAp5eML83fOnjb9th/csTThqTSSdvI3btyY/fI7W3/u8QX+PhKNaid5lIagel2sfFzRbxbPrXt44cKFSUkpmdTWtXbtWvOuY63LOrvdP0MLW73iBRoEDVJvedG4VU//x6O/hSSS1JVhGzZsiN3SUL/PYMnfYjVnlAZ7+yrFAgK4hEHnhZRjt71ZWlR095rHH3kTkoxiJ3v16ia9R9rxwOmuzoeCwd5CuASxWrI6CpzOJ6ori15addddiqyMULQ1idb78BNrJrZ3dzze1e3+NrtE1mlReaWG8wWLzfrk0489cng44b7Rolp3uerxpxa53J5fdnZ1T0hnmQvzco+NLyz4xycfWbUZVEDV8XD9+vUZn7e6Fh050fxwt8c7M12mVAa9PmjPtu4rG1f41PQJJZsaGxtVq2+niROK1rbhQLt7cWeH61+DfaHL4/F4ShZT0ut0UlZm5mf5eY4na2dNf+OeW25RrXjwGTTVYtatW2fa1+6dFe3rW9nW0TUnFI5USEzSdKsWi9ZNxowWdFY02azmX5kiPXtXr16tmaRymj15j/zq2cnuto5r3T7/ikg4Mh2dJeonyToLEdOdkNmcucdps784sab0rQdWrNBcWmaB5sc8YXmvfvp/x0dDvUuaW1tnxiV+oz8QLFR6H5NYypptyWo26Axbi8cVbQ8EQu9W5xvbV61aFQINk1JGjZhLg/lzpy/cVxHq7V3i8QdmUkqm9vWFbeFoJKELxMwmo2TKzPRIcWlfrsP+F4s56xWrKbMV+iZ3r15dr8m8ngORFlZrU1OTft8pV217++krjzW3FKKxU5ehzyhhnNlxrp0Vi8XMsbhkCIfD8tYbk8kYR0s3atAbQlRPeygn/mg8djwuxT+pLi1tKyjK/6TIbPhUZACEFOevGWp4AS0yJHwAAAAASUVORK5CYII=";
  // const [title, setTitle] = useState("");
  const [test, setTest] = useState(false);
  const [show1, setShow1] = useState(false);
  const [err, setErr] = useState("");
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const [previousImage, setPreviousImage] = useState("");
  const [notHuman, setNotHuman] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [contactPeople, setContactPeople] = useState([
    {
      userInfo: {
        countryCode: "",
        phoneNo: "",
        email: "",
        prompt: "",
        password: generatePassword(),
      },
      personInfo: {
        image: "",
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        age: "",
        title: null,
        gender: null,
        nationality: "Guyanese",
      },
    },
  ]);
  const fileInputRef = useRef(null);
  const FaceError = () => {
    messageApi.open({
      // type: 'success',
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="mage" width="50" height="50" />
          <h3>
            Please upload your profile image again; it's not verified as a human
            face.
          </h3>
        </div>
      ),
      duration: 6,
    });
  };

  const addOtherPerson = (check, index) => {
    if (check === "add") {
      setContactPeople([
        ...contactPeople,
        {
          userInfo: {
            countryCode: "",
            phoneNo: "",
            email: "",
            prompt: "",
            password: generatePassword(),
          },
          personInfo: {
            image: "",
            firstName: "",
            lastName: "",
            dateOfBirth: "",
            age: "",
            title: null,
            gender: null,
            nationality: "Guyanese",
          },
        },
      ]);
    } else {
      const updatedContactPeople = [...contactPeople];
      updatedContactPeople.splice(index, 1);
      setContactPeople(updatedContactPeople);
      // setContactPeople(contactPeople.slice(0, -1));
    }
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  };

  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const cryptoKey = await crypto.subtle.digest("SHA-256", buffer);
        const hashArray = Array.from(new Uint8Array(cryptoKey));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        resolve(hashHex);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const imageUploder = async (index, e) => {
    console.log("Image Uploader", e.target.files[0]);
    console.log("Step 1");
    const file = e.target.files[0];
    console.log("file", file);
    const newImageHash = await calculateFileHash(file);

    if (newImageHash === previousImage && notHuman === true) {
      FaceError();
      fileInputRef.current.value = null;
      return;
    }

    if (file) {
      dispatch({ type: "FACE_API", num: true });
      const detectedObjects = await detectObjectsInImage(file);
      // setObjects(detectedObjects);

      const hasHuman = detectedObjects.some(
        (object) => object.class === "person"
      );
      dispatch({ type: "FACE_API", num: false });
      if (hasHuman) {
        setNotHuman(false);
        handleProfileImageChange(index, e);
        console.log("The image contains a human.");
      } else {
        setNotHuman(true);
        setPreviousImage(newImageHash);
        FaceError();
        console.log("The image does not contain a human.");
      }
      fileInputRef.current.value = null;
    }
  };

  const handleProfileImageChange = async (contactIndex, newImageValue) => {
    console.log("step 2", newImageValue);
    const { response, base64 } = await imageHandler(newImageValue, "profile");
    setContactPeople((prevContactPeople) => {
      if (prevContactPeople.length > contactIndex) {
        return prevContactPeople.map((person, personIndex) => {
          if (personIndex === contactIndex) {
            const updatedPerson = { ...person };
            updatedPerson.personInfo.image = response?.data.url;
            return updatedPerson;
          }
          return person;
        });
      }
      return prevContactPeople;
    });
  };
  useEffect(() => {
    console.log("test", contactPeople);
  }, [contactPeople]);

  const imageHandler = async (e, type) => {
    console.log("image handler", e);
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    const bodyFormData = new FormData();
    bodyFormData.append("file", file);
    const api =
      type === "profile"
        ? "merchantContactPersonImage"
        : "merchantIdentificationDocument";

    e.target.value = null;
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/v1/file/merchat-files?fileType=${api}`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      return { response, base64 };
    } catch (err) {
      console.error("Error uploading image:", err);
      throw err;
    }
  };

  function convertToBase64(file) {
    console.log("file", file);
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }

  const handlePersonChange = (index, section, property, value) => {
    const updatedContactPeople = [...contactPeople];

    if (section === "personInfo" && property === "dateOfBirth") {
      if (value && value.isValid()) {
        const birthDate = value.toDate();
        let today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age >= 16) {
          const dobFormatted = dayjs(birthDate).format("MM-DD-YYYY");
          updatedContactPeople[index] = {
            ...updatedContactPeople[index],
            personInfo: {
              ...updatedContactPeople[index].personInfo,
              dateOfBirth: dobFormatted,
              age: age,
            },
          };
        } else {
          setErr("Admin age must be minimum of 16 years.");
          setShow1(true);
          const dobFormatted = dayjs(birthDate).format("MM-DD-YYYY");
          updatedContactPeople[index] = {
            ...updatedContactPeople[index],
            personInfo: {
              ...updatedContactPeople[index].personInfo,
              dateOfBirth: "",
              age: "",
            },
          };
        }
      } else {
        console.error("Invalid date selected:", value);
      }
    } else if (property === "prompt") {
      const wow = parsePhoneNumber(value);
      let countryCode = "";
      let phoneNo = "";

      if (wow) {
        countryCode = `+${wow.countryCallingCode}`;
        phoneNo = wow.nationalNumber;
      } else {
        // Handle invalid phone number input
        console.error("Invalid phone number:", value);
      }

      updatedContactPeople[index] = {
        ...updatedContactPeople[index],
        userInfo: {
          ...updatedContactPeople[index].userInfo,
          countryCode: countryCode,
          phoneNo: phoneNo.toString(), // Ensure phone is stored as a string
          prompt: value, // Update prompt value
        },
      };
    } else {
      updatedContactPeople[index] = {
        ...updatedContactPeople[index],
        [section]: {
          ...updatedContactPeople[index][section],
          [property]: value,
        },
      };
    }

    setContactPeople(updatedContactPeople);
  };
  function getCurrentDate(separator = "") {
    let newDate = new Date();
    let date_raw = newDate.getDate();
    let month_raw = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    var date, month;

    if (date_raw < 10) {
      date = "0" + date_raw.toString();
    } else {
      date = date_raw.toString();
    }
    if (month_raw < 10) {
      month = "0" + month_raw.toString();
    } else {
      month = month_raw.toString();
    }

    return (
      <div>
        {year}
        {separator}
        {month}
        {separator}
        {date}
      </div>
    );
  }
  const date1 = getCurrentDate();
  const disabledBeforeDate1 = moment(
    `${date1.props.children[0]}-${date1.props.children[2]}-${date1.props.children[4]}`
  );
  const disabledDate1 = (current) => {
    return current && current > disabledBeforeDate1;
  };
  const handleNext = () => {
    const body = contactPeople.map((people) => {
      const {
        userInfo: { prompt, ...userRest },
        personInfo: { age, middleName, ...personRest },
      } = people;
      if (middleName === "") {
        delete personRest.middleName;
      } else {
        personRest.middleName = middleName;
      }
      return {
        userInfo: userRest,
        personInfo: personRest,
      };
    });
    console.log("testing", body);
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/merch-auth/merch-admins/bulk-register`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        dispatch({ type: "IINCREMENT" });
      })
      .catch((err) => {
        if (
          err.response.data.message === '"image" is not allowed to be empty'
        ) {
          setErr("Please uplaod a profile picture");
        } else if (
          err?.response?.data?.message === `"email" is not allowed to be empty`
        ) {
          setErr("Please Enter email address");
        } else if (
          err?.response?.data?.message ===
          `"phoneNo" is not allowed to be empty`
        ) {
          setErr("Please Enter Phone Number");
        } else if (
          err?.response?.data?.message ===
          `"title" must be one of [Mr., Mrs., Miss.]`
        ) {
          setErr("Please Select a title");
        } else if (
          err?.response?.data?.message ===
          `"firstName" is not allowed to be empty`
        ) {
          setErr("Please Enter First Name");
        } else if (
          err?.response?.data?.message ===
          `"lastName" is not allowed to be empty`
        ) {
          setErr("Please Enter Last Name");
        } else if (
          err?.response?.data?.message === `"dateOfBirth" must be a valid date`
        ) {
          setErr("Please Enter Date of Birth");
        } else if (
          err?.response?.data?.message ===
          `"gender" must be one of [Male, Female, Non-Binary, Transgender]`
        ) {
          setErr("Please Select Gender");
        } else if (
          err?.response?.data?.message === `"nationality" must be a string`
        ) {
          setErr("Please Select Nationality");
        } else {
          setErr(err?.response?.data?.message);
        }
        setShow1(true);
      });
  };
  return (
    <div>
      <form action="" className="mt-10 sm:mt-[2rem]">
        {contextHolder}
        <div className="p-4">
          {contactPeople?.map((add, index) => {
            return (
              <div className=" mb-[3rem] flex flex-col items-center justify-center w-full">
                <div
                  className={`flex justify-end  sm:w-[74%] w-[80%] cursor-pointermt-[3rem] ${
                    index === 0 ? "hidden" : ""
                  }`}
                  onClick={() => addOtherPerson("remove", index)}
                >
                  <p className="text-[red] underline cursor-pointer text-[0.94rem]">
                    Remove Admin Details
                  </p>
                </div>
                <div className="flex items-center justify-center mb-4 w-full flex-col mt-2">
                  <label className="cursor-pointer relative">
                    <div className="relative w-[8.5rem] h-[8.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
                      <img
                        className="object-cover w-[8.5rem] h-[8.5rem]"
                        src={
                          contactPeople[index]?.personInfo?.image !== ""
                            ? contactPeople[index]?.personInfo?.image
                            : photo
                        }
                        alt=""
                      />
                    </div>

                    <div
                      className={`bg-primary rounded-full absolute bottom-4 right-2`}
                    >
                      <img src={check} className="lg:w-7 w-5" alt="" />
                    </div>
                    <input
                      type="file"
                      className="hidden"
                      accept="image/png, image/gif, image/jpeg"
                      onInput={(e) => {
                        imageUploder(index, e);
                      }}
                      ref={fileInputRef}
                    />
                  </label>
                  <h2 className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                    Upload Admin Picture
                  </h2>
                </div>
                {/* Name */}
                <div className="flex justify-center w-full items-center">
                  <div className="grid sm:grid-cols-2 sm:gap-2 grid-cols-1 sm:w-[74%] w-[80%]">
                    <div className="w-[100%]">
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Title <span className="text-red-600">*</span>
                        </label>
                        <Select
                          placeholder="Title"
                          optionFilterProp="children"
                          className="wow"
                          style={{ marginBottom: "1.2rem" }}
                          value={contactPeople[index]?.personInfo?.title}
                          onChange={(value) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "title",
                              value
                            )
                          }
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          size="middle"
                          options={[
                            {
                              value: "Mr.",
                              label: "Mr.",
                            },
                            {
                              value: "Mrs.",
                              label: "Mrs.",
                            },
                            {
                              value: "Miss.",
                              label: "Miss.",
                            },
                          ]}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          First Name <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "firstName",
                              e.target.value
                            )
                          }
                          value={contactPeople[index]?.personInfo?.firstName}
                          placeholder="First Name"
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Middle Name
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "middleName",
                              e.target.value
                            )
                          }
                          value={contactPeople[index]?.personInfo?.middleName}
                          placeholder="Middle Name"
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Last Name <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "lastName",
                              e.target.value
                            )
                          }
                          value={contactPeople[index]?.personInfo?.lastName}
                          placeholder="Last Name"
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                        />
                      </div>
                    </div>
                    <div className="w-[100%]">
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Date of Birth <span className="text-red-600">*</span>
                        </label>
                        <DatePicker
                          style={{ marginBottom: "1.2rem" }}
                          disabledDate={disabledDate1}
                          // value={
                          //   contactPeople[index]?.personInfo?.dateOfBirth
                          //     ? dayjs(
                          //         contactPeople[index]?.personInfo?.dateOfBirth
                          //       ).format("DD-MM-YYYY")
                          //     : null
                          // }
                          value={
                            contactPeople[index]?.personInfo?.dateOfBirth
                              ? dayjs(
                                  contactPeople[index]?.personInfo?.dateOfBirth
                                )
                              : null
                          }
                          className="date-class"
                          onChange={(date) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "dateOfBirth",
                              date
                            )
                          }
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Age <span className="text-red-600">*</span>
                        </label>
                        <input
                          style={{ marginBottom: "1.2rem" }}
                          className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                          value={`${
                            contactPeople[index]?.personInfo?.age === ""
                              ? ""
                              : `${contactPeople[index]?.personInfo?.age} year`
                          }`}
                          readOnly
                          placeholder="Age"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Nationality <span className="text-red-600">*</span>
                        </label>
                        <Select
                          placeholder="Nationality"
                          showSearch
                          className="wow"
                          value={contactPeople[index]?.personInfo?.nationality}
                          onChange={(e) =>
                            handlePersonChange(
                              index,
                              "personInfo",
                              "nationality",
                              e
                            )
                          }
                          optionFilterProp="children"
                          style={{
                            marginBottom: "1rem",
                          }}
                          filterOption={(input, option) =>
                            (option?.lable ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          size="middle"
                          options={rr}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                          Gender <span className="text-red-600">*</span>
                        </label>
                        <Select
                          placeholder="Gender"
                          optionFilterProp="children"
                          className="wow"
                          value={contactPeople[index]?.personInfo?.gender}
                          style={{ marginBottom: "1.2rem" }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          size="middle"
                          onChange={(e) =>
                            handlePersonChange(index, "personInfo", "gender", e)
                          }
                          options={[
                            {
                              value: "Male",
                              label: "Male",
                            },
                            {
                              value: "Female",
                              label: "Female",
                            },
                            {
                              value: "Non-Binary",
                              label: "Non-Binary",
                            },
                            {
                              value: "Transgender",
                              label: "Transgender",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-50  sm:w-[74%] w-[80%] p-4 rounded-lg shadow-lg md:ml-[8rem] md:mr-[8rem] sm:mr-[2rem] sm:ml-[2rem] mt-6 border border-slate-200">
                  <div>
                    <div className="mb-4">
                      <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                        Phone <span className="text-red-600">*</span>
                      </label>
                      <PhoneInput
                        placeholder="Enter phone number"
                        defaultCountry="GY"
                        value={contactPeople[index]?.userInfo?.prompt}
                        onChange={(e) =>
                          handlePersonChange(index, "userInfo", "prompt", e)
                        }
                        international
                        countryCallingCodeEditable={false}
                        required
                        className=".PhoneInputCountryIcon .PhoneInputCountrySelectArrow"
                      />
                    </div>

                    <div className="flex flex-col mb-4">
                      <label
                        htmlFor="input1"
                        className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                      >
                        Email <span className="text-red-600">*</span>
                      </label>
                      <input
                        className="lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2"
                        type="text"
                        placeholder="Email"
                        onChange={(e) =>
                          handlePersonChange(
                            index,
                            "userInfo",
                            "email",
                            e.target.value
                          )
                        }
                        value={contactPeople[index]?.userInfo?.email}
                        id="input1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div
            className="flex justify-center items-center mt-14"
            onClick={() => addOtherPerson("add")}
          >
            <div className="flex justify-center items-center cursor-pointer">
              <PlusCircleFilled className=" text-primary flex justify-center items-center text-2xl mr-2" />
              <p className="text-primary">Add More Admin Details</p>
            </div>
          </div>
        </div>
      </form>
      <div className="flex items-center justify-center p-4">
        <div
          className={`lg:mt-[3rem]  flex mt-4 items-center sm:justify-end  gap-2 justify-center  sm:w-[74%] w-[80%]`}
        >
          <button
            type="button"
            // onClick={() => {}}
            onClick={() => dispatch({ type: "IINCREMENT" })}
            className={`lg:text-[1.1rem] bg-gradient-to-tr bg-gray-400 text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Skip
          </button>
          <button
            type="button"
            onClick={handleNext}
            // onClick={() => dispatch({ type: "IINCREMENT" })}
            className={`lg:text-[1.1rem] bg-gradient-to-tr bg-primary text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Next
          </button>
        </div>
      </div>
      <div
        className={`${
          show ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => {
              // setOne(false);
              setShow(false);
            }}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">
            {/* {ageError} */}
            {/* For old age pension program you should be or older than 65 years. */}
          </p>
          <button
            onClick={() => {
              // setOne(false);
              setShow(false);
            }}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          show1 ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-10`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow1(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            type="button"
            onClick={() => setShow1(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default Mid;
